// General constants
export const IS_REFRESHING = 'isolateRelease/IS_REFRESHING';

// refresh
export const REFRESH_RELEASES_FOR_ISOLATE =
  'isolateRelease/REFRESH_RELEASES_FOR_ISOLATE';
export const REFRESH_RELEASES_FOR_ISOLATE_SUCCESS =
  'isolateRelease/REFRESH_RELEASES_FOR_ISOLATE_SUCCESS';
